import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const badgeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elements = [badgeRef.current, headingRef.current, subRef.current];
    elements.forEach((el, i) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = `opacity 0.8s ease ${i * 0.18}s, transform 0.8s ease ${i * 0.18}s`;
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (el) {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }
        }, 80);
      });
    });
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/9f71dcdcc3fff4189ac208c3972d0997.jpg"
          alt="KROKO iOS security technology background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div ref={badgeRef} className="inline-flex items-center gap-2 mb-8">
          <span className="block w-6 h-px bg-[#C74B1C]" />
          <span className="text-[#C74B1C] text-sm font-semibold tracking-[0.2em] uppercase">
            iOS App Development
          </span>
          <span className="block w-6 h-px bg-[#C74B1C]" />
        </div>

        <h1
          ref={headingRef}
          className="text-white font-extrabold leading-tight mb-6"
          style={{ fontFamily: 'Syne, sans-serif', fontSize: 'clamp(2.5rem, 6vw, 5rem)' }}
        >
          Modern Applications for
          <br />
          <span className="text-[#C74B1C]">iOS Security</span> &amp; Performance
        </h1>

        <p
          ref={subRef}
          className="text-white/75 text-lg leading-relaxed max-w-2xl mx-auto"
        >
          KROKO d.o.o. is a dedicated team of experts crafting premium iOS applications
          — including our flagship VPN and Cleaner tools — designed to elevate your
          mobile experience and protect your digital life.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 opacity-60">
          <span className="text-white/60 text-xs tracking-widest uppercase">Scroll to explore</span>
          <div className="w-5 h-8 border border-white/40 rounded-full flex items-start justify-center pt-1.5">
            <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}
